import React from 'react'

const DashboardNodes = () => {
  return (
    <div>
             <table class="table table-responsive dasboardDataTable">
            <thead>
                <tr>
                <th scope="col" className='tableHead'>ID</th>
                <th scope="col" className='tableHead'>Nodes</th>
                <th scope="col" className='tableHead'>Date  </th>
                <th scope="col" className='tableHead'>Payment</th>
                <th scope="col"></th>

                </tr>
            </thead>
            <tbody>
                <tr>
                    <td># 2154 5684</td>
                    <td>X0sfhg..fsghasfasfga</td>
                    <td>04-12-24 14:08</td>
                    <td>$830/week</td>
                    <td className='table_btn'>
                        <button className='header_btn gradient-cta position-relative' >Cancel</button> 
                    </td>
                </tr>
                <tr>
                    <td># 2154 5684</td>
                    <td>X0sfhg..fsghasfasfga</td>
                    <td>04-12-24 14:08</td>
                    <td>$830/week</td>
                    <td className='table_btn'>
                        <button className='header_btn gradient-cta position-relative' >Cancel</button> 
                    </td>
                </tr>
                <tr>
                    <td># 2154 5684</td>
                    <td>X0sfhg..fsghasfasfga</td>
                    <td>04-12-24 14:08</td>
                    <td>$830/week</td>
                    <td className='table_btn'>
                        <button className='header_btn gradient-cta position-relative' >Cancel</button> 
                    </td>
                </tr>
                <tr>
                    <td># 2154 5684</td>
                    <td>X0sfhg..fsghasfasfga</td>
                    <td>04-12-24 14:08</td>
                    <td>$830/week</td>
                    <td className='table_btn'>
                        <button className='header_btn gradient-cta position-relative' >Cancel</button> 
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
  )
}

export default DashboardNodes